module.exports = __webpack_public_path__ + "static/media/defense_bundle_hero.4f1f7e0e.png";